import { Selectors } from '@grandvisionhq/auth';
import { useSelector } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import 'react';
import { shouldCreateAccount } from '../../selectors.js';

const useShouldCreateAccount = ()=>{
    const shouldCreateAccount$1 = useSelector(shouldCreateAccount);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { account  } = useCheckoutSettings();
    if (isLoggedIn) {
        return false;
    } else if (!isLoggedIn && (account === null || account === void 0 ? void 0 : account.createAccountRequired)) {
        return true;
    } else if (shouldCreateAccount$1 !== undefined) {
        return shouldCreateAccount$1;
    } else {
        return false;
    }
};

export { useShouldCreateAccount };
//# sourceMappingURL=use-should-create-account.js.map
